module.exports = __webpack_public_path__ + "assets/employer-links-logo.3b9f1c9f.jpg";